import React from "react";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";
import { CategoryData } from "../../types/category";
import FileForm from "../common/FileForm";
import { useStore } from "../../app/stores/store";
import { observer } from "mobx-react-lite";

type Props = {
  category: CategoryData;
};

const CategoryCard = ({ category }: Props) => {
  const {
    userStore: { isAdmin },
    categoryStore: { uploadImage },
  } = useStore();

  const formattedName = category.name.replace(/\s+/g, "-");

  return (
    <div className="relative">
      <Link to={`/services/${formattedName}/${category.id}`}>
        <div className="rounded-2xl border-2 border-transparent hover:border-[#e71875] hover:shadow-xl transition-all duration-300 group overflow-hidden text-center bg-white cursor-pointer">
          <div className="p-0 bg-pink-50 relative w-full h-32 flex items-center justify-center overflow-hidden">
            <ImageWithBasePath
              lazyLoad
              src={
                category.fileEntities?.[0]?.filePath ||
                "assets/img/Amer Services.png"
              }
              alt={category.name ?? "Category"}
              className="object-contain w-full h-full transition-transform duration-300 group-hover:scale-105"
            />
          </div>

          <div className="p-4">
            <h3 className="text-xl font-bold text-primary">{category.name}</h3>
            <p className="mt-2 text-sm text-neutral-600">
              {category.description}
            </p>
          </div>

          <div className="pb-4">
            <p className="w-full text-center text-primary font-semibold border-t-2 border-dashed border-pink-200 pt-2 mx-4">
              {"Apply Now"}
            </p>
          </div>
        </div>
      </Link>

      {/* FileForm outside the Link */}
      {uploadImage && isAdmin() && (
        <div className="absolute top-2 right-2 z-10">
          <FileForm label="" entityId={category.id} uploadImage={uploadImage} />
        </div>
      )}
    </div>
  );
};

export default observer(CategoryCard);
